import { IWfPopoverProps, WfPopover } from "src/components/base/wf-popover";

export const WfTooltip = (props: Omit<IWfPopoverProps, "trigger">) => <WfPopover trigger="hover" {...props} />;
